import * as React from "react";
const SvgDesc = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 10, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#969696", d: "M14.17-2.08 10-6.25 5.83-2.08zm0 4.16L10 6.25 5.83 2.08z" }));
export default SvgDesc;
